export default __webpack_public_path__ + "static/media/right-btn.f3d2df7b.svg";